import 'pnotify/dist/pnotify.css';
import 'pnotify/dist/pnotify.brighttheme.css';
import 'pnotify/dist/pnotify.buttons.css';
import 'pnotify/dist/pnotify.buttons';
import PNotify from 'pnotify';

export function success(title, text, xCordinate = 25, yCordinate = 25, delay = 600, className='metype-notification') {
  const stack_custom = {"dir1": "down", "dir2": "left", "firstpos1": yCordinate, "firstpos2": xCordinate};
  new PNotify({
    title: title,
    text: text,
    type: 'success',
    icon:false,
    delay,
    addclass: className,
    stack: stack_custom,
    nonblock: {
      nonblock: true
    }
  });
}


export function error(title, text, xCordinate = 25, yCordinate = 25, delay = 600) {
  const stack_custom = {"dir1": "down", "dir2": "left", "firstpos1": yCordinate, "firstpos2": xCordinate};
  new PNotify({
    title: title,
    text: text,
    type: 'error',
    icon:false,
    delay,
    addclass: 'metype-notification',
    stack: stack_custom,
    nonblock: {
      nonblock: true
    }
  });
}


// WEBPACK FOOTER //
// ./app/javascript/util/pnotify.js